import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader } from 'antd';

import { pageSectionTitle } from '../util/Style';
import SelectStartEndDateAndInterval from './SelectDateAndInterval';

import { AgGridReact } from 'ag-grid-react';

const height = window.innerHeight * .75;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const columnDefs = [
    { headerName: 'ReferrerName', field: 'Doctorname', width: 75 },
    { headerName: 'Change', field: 'change', width: 100 },
    { headerName: 'First TransactionDate', field: 'firstTransactionDate', filter: 'agTextColumnFilter', width: 350 },
    { headerName: 'Last TransactionDate', field: 'lastTransactionDate', filter: 'agTextColumnFilter', width: 350 },
]

class ReferrerGrid extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    fetchReferrerSummary = () => {
        this.store.fetchSummary();
    }

    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const referrerId = selectedRows[0].ReferrerId;
        const doctorName = selectedRows[0].Doctorname;
        const collectionType = selectedRows[0].collectionType;
        this.store.updateReferrerId(referrerId, doctorName);
        // this.store.publishLabChart(referrerId, doctorName, collectionType);
        this.store.clearSelectedReferrer();
    }

    render() {
        return (
            <PageHeader style={{ }} 
                title={pageSectionTitle(this.props.title)} 
                extra = {<SelectStartEndDateAndInterval store = {this.store}/>} >
                <div className="ag-theme-alpine" style={{ height: height, width: '100%', marginTop:'5px' }}>
                    <AgGridReact
                            ref={this.gridRef}
                            defaultColDef={defaultColDef}
                            rowData={this.store.referrerData}
                            columnDefs={columnDefs}
                            rowSelection={'single'}
                            onSelectionChanged={this.onSelectionChanged}
                            onGridReady={this.fetchReferrerSummary}
                            rowHeight={30} >
                    </AgGridReact>
                </div>
            </PageHeader>
        )
    }
}

export default observer(ReferrerGrid)
